export { default } from './Details';